import AppContext from '@aurora/shared-client/components/context/AppContext/AppContext';
import useEndUserRoutes from '@aurora/shared-client/routes/useEndUserRoutes';
import { EndUserComponent, EndUserPages } from '@aurora/shared-types/pages/enums';
import type { NextSeoProps } from 'next-seo';
import React, { useContext } from 'react';
import type { BreadcrumbItem } from '../../../components/context/BreadcrumbContext/BreadcrumbContext';
import BasePage from '../../../components/page/BasePage/BasePage';
import useTranslation from '../../../components/useTranslation';
import { isPageIndexable } from '../../../helpers/messages/MessageHelper/MessageHelper';

/**
 * IdeaViewAllIdeas Page
 *
 * @author kiran.kumari
 */
const IdeaViewAllIdeasPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { formatMessage } = useTranslation(EndUserComponent.IDEA_VIEW_ALL_IDEAS_PAGE);
  const { contextNode } = useContext(AppContext);
  const { router } = useEndUserRoutes();
  const isIndexable = isPageIndexable(router);

  /**
   * This function returns the array of breadcrumbs for the ideaViewAllIdeas Page to be displayed
   * @param breadcrumbs the breadcrumb item that is to be displayed
   * @returns array of the breadcrumb items
   */
  function decorateBreadcrumbs(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
    return [
      ...breadcrumbs,
      {
        id: 'page:IdeaViewAllIdeasPage',
        title: formatMessage('breadCrumbTitle')
      }
    ];
  }

  const nextSeoProps: NextSeoProps = {
    canonical: router.asPath,
    nofollow: !isIndexable,
    noindex: !isIndexable,
    title: formatMessage('title', { boardName: contextNode.displayId })
  };

  return (
    <BasePage
      pageId={EndUserPages.IdeaViewAllIdeasPage}
      nextSeoProps={nextSeoProps}
      decorateBreadcrumbs={decorateBreadcrumbs}
    />
  );
};
export default IdeaViewAllIdeasPage;
